import defaultConfig from './appConfigFiles/default.json';
import freeConfig from './appConfigFiles/free.json';
import basicConfig from './appConfigFiles/basic.json';
import proConfig from './appConfigFiles/pro.json';
import dalgasConfig from './appConfigFiles/dalgas.json';
import dmogeFreeConfig from './appConfigFiles/dmogeFree.json';
import dmogePayedConfig from './appConfigFiles/dmogePayed.json';
import dmogeYellowConfig from './appConfigFiles/dmogeYellow.json';
import dshWoodChipsConfig from './appConfigFiles/dshWoodChips.json';
import { AppConfigOverride } from 'types/appFunctionality';

type SubscriptionConfigDefinition = {
  brands: readonly ('forsler' | 'skovkortet' | 'george')[];
  config: AppConfigOverride;
};

// The home brands and configuration for each organisation subscription.
// This controls config selection/inheritance, not login access or redirects.
// George entries inherit george.json; Forsler/Skovkortet entries inherit default.json.
// Unmatched subscriptions on George retain the ordinary George experience.
export const SUBSCRIPTION_CONFIGS: Readonly<Record<string, SubscriptionConfigDefinition>> = {
  trial: { brands: ['forsler', 'skovkortet'], config: defaultConfig as AppConfigOverride },
  free: { brands: ['forsler', 'skovkortet'], config: freeConfig as AppConfigOverride },
  basic: { brands: ['forsler', 'skovkortet'], config: basicConfig as AppConfigOverride },
  pro: { brands: ['forsler', 'skovkortet'], config: proConfig as AppConfigOverride },
  advanced: { brands: ['forsler', 'skovkortet'], config: defaultConfig as AppConfigOverride },
  dalgas: { brands: ['forsler', 'skovkortet'], config: dalgasConfig as AppConfigOverride },
  dmogeFree: { brands: ['forsler', 'skovkortet'], config: dmogeFreeConfig as AppConfigOverride },
  dmogePayed: { brands: ['forsler', 'skovkortet'], config: dmogePayedConfig as AppConfigOverride },
  dshWoodChips: { brands: ['forsler', 'skovkortet'], config: dshWoodChipsConfig as AppConfigOverride },
  dmogeYellow: { brands: ['george'], config: dmogeYellowConfig as AppConfigOverride },
};
